import { Theme, Tooltip, Typography, useTheme } from '@mui/material';
import { CategoryDisplayName } from '@oxappsec/ox-consolidated-categories';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { ArtifactCategories } from '../../artifacts/types/artifacts-type';
import { artifactsCategories } from '../../artifacts/utils/artifacts-utils';
import { SeverityAlert, SeverityType } from 'common-types';
import IssueBadge from '../../common/components/IssueBadge';
import { MdDone } from 'react-icons/md';

const SeverityHeatMap: FC<SeverityHeatMapProps> = ({ data, top }) => {
  const theme = useTheme();
  const { classes } = useStyles();
  return (
    <div className={classes.severityHeatMap}>
      {artifactsCategories.map((item, index) => {
        const artifactCategory = data.find(
          artifactCategory => artifactCategory.name === item.value,
        );
        return (
          <Tooltip
            key={index}
            arrow
            placement='top'
            title={
              <div>
                <Typography variant='body2' color='text.primary' mb={0.5}>
                  {item.value}
                </Typography>
                {artifactCategory?.severities ? (
                  <IssueBadge
                    severitiesAlerts={artifactCategory?.severities}
                    fontSize='0.7rem'
                  />
                ) : (
                  <div className={classes.noIssues}>
                    <MdDone color='green' size='1rem' />
                    <Typography variant='body2' color='text.secondary'>
                      No Issues
                    </Typography>
                  </div>
                )}
              </div>
            }>
            <span
              className={classes.severityItem}
              style={{
                backgroundColor:
                  theme.palette.categoryRiskColor[
                    artifactCategory && artifactCategory.score
                      ? artifactCategory.score
                      : 'none'
                  ],
              }}
            />
          </Tooltip>
        );
      })}
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  severityHeatMap: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    textOverflow: 'ellipsis',
  },
  severityItem: {
    borderRadius: 2,
    border: 'none',
    display: 'inline-block',
    width: 8,
    height: 8,
  },
  noIssues: {
    display: 'inline-flex',
    gap: theme.spacing(0.5),
  },
}));

export interface SeverityHeatMapProps {
  data: ArtifactCategories[];
  top?: number;
}

export interface SeverityHeatMapItem {
  severityMap: SeverityAlert;
  severity: SeverityType;
  category: CategoryDisplayName;
}

export default SeverityHeatMap;
